import { baseCMSApi } from '@/shared/api/base-cms-api';
import { CMS_ENDPOINTS } from '@/shared/api/endpoints';

import type { Footer } from '../model/types/footer';

const footerApi = baseCMSApi
    .enhanceEndpoints({
        addTagTypes: ['Footer'],
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getFooterContent: build.query<Footer, { locale: string }>({
                query: (params) => ({
                    url: CMS_ENDPOINTS.getFooter(),
                    method: 'GET',
                    params: {
                        locale: params.locale,
                        depth: 2,
                    },
                }),
                providesTags: ['Footer'],
            }),
        }),
    });

export const { useGetFooterContentQuery } = footerApi;
